module.exports = __webpack_public_path__ + "static/media/MainAmbience.cb39bd7f.mp3";